import styled from 'styled-components';

export const CellNoEllipsisContent = styled.div`
  margin: 0;
  overflow: visible !important;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;
